// extracted by mini-css-extract-plugin
export var width100 = "N_w d_w";
export var design3Pos = "N_xD d_0";